module.exports = __webpack_public_path__ + "static/video-still-0e46f69e7e1222d749bca6c1e446b2ba.jpg";